// 订单管理
const api = {
  list: {
    url: '/mall/cityarea/get?id=0',
    type: 'GET',
    parameter: {}
  },
  get: {
    url: '/mall/cityarea/get',
    type: 'get',
    parameter: {}
  }
}

export default api
